import { MenuItem, TextField, TextFieldProps } from '@mui/material'
import React, { InputHTMLAttributes, useMemo } from 'react' // Import MUI TextField component
import { useField } from 'formik' // Import formik hook
import {
  AdditionalDocumentsType,
  CityIndex,
  LicenseType,
} from '../../types/interface' // Import city definition

interface SelectWrapperProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string
  options: AdditionalDocumentsType[] | CityIndex[] | LicenseType[]
}

const SelectWrapper: React.FC<SelectWrapperProps & TextFieldProps> = ({
  name,
  options,
  ...otherProps
}) => {
  const [field, meta] = useField(name)

  const configSelect = useMemo(() => {
    const config = {
      ...field,
      ...otherProps,
      fullWidth: true,
      select: true,
      value: field.value || '',
      variant: 'outlined',
    } as TextFieldProps

    if (meta && meta.touched && meta.error) {
      return {
        ...config,
        error: true,
        helperText: meta.error,
      }
    }

    return config
  }, [field, otherProps, meta])

  return (
    <TextField {...configSelect}>
      {options.map((item, index) => (
        <MenuItem key={index} value={item.id}>
          {item.name}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default SelectWrapper
